import Layout from "components/Layout";
import RCAAppDrawerItems from "../RCAAppDrawerItems";
import { IRCALayout } from "./RCALayoutInterfaces";
import Module2Icon from "components/Module2Icon";
import { useStyles } from "./RCALayout.styles";
import { useTranslation } from "react-i18next";

const RCALayout = ({ children }: IRCALayout) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <Layout
            rca
            appDrawerItems={<RCAAppDrawerItems />}
            navLabel={t("rca.drawer_items.nav_label")}
            toolbarLogo={
                <>
                    <Module2Icon /> <span className={classes.mainTitle}>RCA/AP</span>
                </>
            }
        >
            {children}
        </Layout>
    );
};

export default RCALayout;
